import { useEffect, useState } from 'react';
import { VisualNavigationType } from 'corgi-types';

import type {
  UseLoadVisualNavigationArgs,
  UseLoadVisualNavigationOutput,
} from '../../types/visual-navigation';
import { useGQLLocale } from '../locale';
import { getShowroomLoaderParams, loadShowroomItems } from './loaders/showrooms';

export const useLoadVisualNavigation = ({
  items: initialItems = [],
  type,
  ...restProps
}: UseLoadVisualNavigationArgs): UseLoadVisualNavigationOutput => {
  const locale = useGQLLocale();
  const [loaded, setLoaded] = useState(type === VisualNavigationType.Default);
  const [items, setItems] = useState(initialItems);
  const [error, setError] = useState<Error>(null);

  useEffect(() => {
    if (type === VisualNavigationType.Showroom) {
      const commonParams = {
        locale,
        setLoaded,
        setItems,
        setError,
      };

      const loadVisualNavigationItems = loadShowroomItems({
        ...getShowroomLoaderParams(restProps),
        ...commonParams,
      });

      loadVisualNavigationItems();
    }
  }, [type]);

  return { items, loaded, error };
};
